import React, { useCallback, useEffect, useState } from "react";

//Hooks
import { useToasts } from "@magento/peregrine";
import { useApp } from "@magento/peregrine/lib/talons/App/useApp";
import UIkit from "uikit";
window.UIkit = UIkit;

//Components
import { HeadProvider, Title } from "@magento/venia-ui/lib/components/Head";
import Main from "../overrides/venia-ui/components/Main";
import Mask from "@magento/venia-ui/lib/components/Mask";
import Navigation from "@overrides_venia/venia-ui/components/Navigation";
import Routes from "../Routes";
import ToastContainer from "@magento/venia-ui/lib/components/ToastContainer";
import Icon from "../components/Icon";
import GoogleTagManager from "../components/GoogleTagManager/GoogleTagManager";
import { isThisCookieSupported } from "@Components/SpecificCookiesChecks/cookiesTypes";
import { ErrorBoundary } from "./ErrorBoundary";
import { SchemaLocalBusiness } from "../components/SchemaOrg/SchemaLocalBusiness";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import { FirebaseProvider } from "@Src_main/backend";
import { GlobalLoadingIndicator } from "@overrides_venia/venia-ui/components/LoadingIndicator/indicator";
import FooterNav from "@overrides_venia/venia-ui/components/FooterNav";
import { env } from "build/env";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useExponea } from "@Src_main/utils/useExponea";
import { LanguageSelector } from "@Components/LanguageSelector/languageSelector";
var OnlineIcon = /*#__PURE__*/React.createElement(Icon, {
  name: "icon-error"
});
var OfflineIcon = /*#__PURE__*/React.createElement(Icon, {
  name: "icon-error"
});
var ErrorIcon = /*#__PURE__*/React.createElement(Icon, {
  name: "icon-error"
});
var UpdateIcon = /*#__PURE__*/React.createElement(Icon, {
  name: "icon-error"
});
var ERROR_MESSAGE = "Sorry! An unexpected error occurred.";
var App = props => {
  var {
    markErrorHandled,
    renderError,
    unhandledErrors
  } = props;
  var [, {
    addToast
  }] = useToasts();
  var {
    isMobile
  } = useWindowSize();
  var [isExponeaTrackingActive, setIsExponeaTrackingActive] = useState(null);
  var {
    trackAllEvent
  } = useExponea();
  var handleIsOffline = useCallback(() => {
    addToast({
      type: "error",
      icon: OfflineIcon,
      message: "You are offline. Some features may be unavailable.",
      timeout: 3000
    });
  }, [addToast]);
  var handleIsOnline = useCallback(() => {
    addToast({
      type: "info",
      icon: OnlineIcon,
      message: "You are online.",
      timeout: 3000
    });
  }, [addToast]);
  var handleHTMLUpdate = useCallback(resetHTMLUpdateAvaiableFlag => {
    addToast({
      type: "warning",
      icon: UpdateIcon,
      message: "Update available. Please refresh.",
      actionText: "Refresh",
      timeout: 0,
      onAction: () => {
        location.reload();
      },
      onDismiss: removeToast => {
        resetHTMLUpdateAvaiableFlag();
        removeToast();
      }
    });
  }, [addToast]);
  var handleError = useCallback((error, id, loc, handleDismissError) => {
    var errorToastProps = {
      icon: ErrorIcon,
      message: "".concat(ERROR_MESSAGE, "\nDebug: ").concat(id, " ").concat(loc),
      onDismiss: remove => {
        handleDismissError();
        remove();
      },
      timeout: 15000,
      type: "error"
    };
    addToast(errorToastProps);
  }, [addToast]);
  var talonProps = useApp({
    handleError,
    handleIsOffline,
    handleIsOnline,
    handleHTMLUpdate,
    markErrorHandled,
    renderError,
    unhandledErrors
  });
  useEffect(() => {
    var exponeaSampling = sessionStorage.getItem("exponea_sampling");
    if (exponeaSampling) {
      var {
        is_log_active,
        log_value,
        log_threshold
      } = JSON.parse(exponeaSampling);
      console.log("Exponea sampling already set", is_log_active, log_value, log_threshold);
      setIsExponeaTrackingActive(is_log_active);
    } else {
      var _log_threshold = parseFloat(env.EXPONEA_SAMPLING_RATE);
      var _log_value = Math.random();
      var _is_log_active = _log_value < _log_threshold;
      var _exponeaSampling = JSON.stringify({
        is_log_active: _is_log_active,
        log_value: _log_value,
        log_threshold: _log_threshold
      });
      sessionStorage.setItem("exponea_sampling", _exponeaSampling);
      console.log("exponea sampling status", _is_log_active, _log_value, _log_threshold);
      setIsExponeaTrackingActive(_is_log_active);
    }
  }, []);
  useEffect(() => {
    if (isExponeaTrackingActive === true || isExponeaTrackingActive === false) {
      trackAllEvent("page_visit", {
        is_exponea_active: isExponeaTrackingActive
      });
    }
  }, [location.pathname, isExponeaTrackingActive]);
  var {
    hasOverlay
  } = talonProps;
  if (renderError) {
    return /*#__PURE__*/React.createElement(HeadProvider, null, /*#__PURE__*/React.createElement(Title, null, "".concat(STORE_NAME)), /*#__PURE__*/React.createElement(Main, {
      isMasked: true
    }), /*#__PURE__*/React.createElement(Mask, {
      isActive: true
    }), /*#__PURE__*/React.createElement(ToastContainer, null));
  }
  return /*#__PURE__*/React.createElement(HeadProvider, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(SchemaLocalBusiness, {
    image: "https://imagesmiscusi.blob.core.windows.net/assets/miscusi_logo_mobile_red.svg",
    logo: "https://imagesmiscusi.blob.core.windows.net/assets/miscusi_logo_mobile_red.svg"
  }), /*#__PURE__*/React.createElement(Title, null, "".concat(STORE_NAME)), /*#__PURE__*/React.createElement(GlobalLoadingIndicator, null), /*#__PURE__*/React.createElement(FirebaseProvider, null, /*#__PURE__*/React.createElement(Main, {
    isMasked: hasOverlay
  }, /*#__PURE__*/React.createElement(Routes, null), isThisCookieSupported("thirdPartyCookie") ? /*#__PURE__*/React.createElement(GoogleTagManager, null) : null)), isOrderActive && isMobile ? /*#__PURE__*/React.createElement(FooterNav, null) : /*#__PURE__*/React.createElement(Navigation, null), /*#__PURE__*/React.createElement(LanguageSelector, null), /*#__PURE__*/React.createElement(ToastContainer, null)));
};
export default App;